import { ExportKey } from '@/features/scheduleExport/types';
import { AnalyticsEvent, AnalyticsEventCategories } from '@/utils/analyticsEvents/categories';

export class ScheduleFilteredCompaniesEvent extends AnalyticsEvent {
  public readonly identification = AnalyticsEventCategories.SCHEDULE_FILTERED_COMPANIES;

  public constructor(
    public properties: {
      companiesSelected: number;
    },
  ) {
    super();
  }
}
export class ScheduleFilteredStructureEvent extends AnalyticsEvent {
  public readonly identification = AnalyticsEventCategories.SCHEDULE_FILTERED_STRUCTURE;

  public constructor(
    public properties: {
      rowsSelected: number;
    },
  ) {
    super();
  }
}

export class ScheduleFilteredTradesEvent extends AnalyticsEvent {
  public readonly identification = AnalyticsEventCategories.SCHEDULE_FILTERED_TRADES;

  public constructor(
    public properties: {
      tradesSelected: number;
    },
  ) {
    super();
  }
}

export class ScheduleViewSettingChangedDependencyVisibilityEvent extends AnalyticsEvent {
  public identification =
    AnalyticsEventCategories.SCHEDULE_VIEW_SETTING_CHANGED_DEPENDENCY_VISIBILITY;

  public constructor(public properties: { show: boolean }) {
    super();
  }
}

export class ExportMenuOpenedEvent extends AnalyticsEvent {
  public readonly identification = AnalyticsEventCategories.EXPORT_MENU_OPENED;

  public constructor(
    public properties: {
      method: 'menu' | 'filters';
    },
  ) {
    super();
  }
}

export type PDFExportAnalyticsEventOrderColor = 'trade' | 'status' | 'base_actual';

export interface PDFExportAnalyticsEventProperties {
  orderColor: PDFExportAnalyticsEventOrderColor;
  timeSpanInDays: number;
  filters: {
    companiesSelected: number;
    rowsSelected: number;
    tradesSelected: number;
  };
  viewSettings: {
    hideDependencies: boolean;
    hideWeekends: boolean;
    showCollisions: boolean;
    showTodayLine: boolean;
  };
  format: {
    orientation: string;
    paperFormat: string;
    isSinglePage: boolean;
  };
}

export class PDFExportEvent extends AnalyticsEvent {
  public readonly identification = AnalyticsEventCategories.EXPORT_PDF;

  public constructor(public properties: PDFExportAnalyticsEventProperties) {
    super();
  }
}

export type ThirdPartyExportAnalyticsEventAllFilters = {
  companiesSelected: number;
  rowsSelected: number;
  tradesSelected: number;
};

export class XLSExportEvent extends AnalyticsEvent {
  public readonly identification = AnalyticsEventCategories.EXPORT_EXCEL;

  public constructor(public properties: { allFilters: ThirdPartyExportAnalyticsEventAllFilters }) {
    super();
  }
}

export class GanttExportEvent extends AnalyticsEvent {
  public readonly identification = AnalyticsEventCategories.EXPORT_GANTT;

  public constructor(
    public properties: {
      type: 'ms_project' | 'powerproject' | 'p6';
      allFilters: ThirdPartyExportAnalyticsEventAllFilters;
      viewSettings: { groupSequences: boolean };
    },
  ) {
    super();
  }
}

export class ExportRetriedEvent extends AnalyticsEvent {
  public readonly identification = AnalyticsEventCategories.EXPORT_RETRIED;

  public constructor(
    public properties: {
      exportType: ExportKey;
    },
  ) {
    super();
  }
}
